import { useState, useEffect, useRef } from "react";
import { useHistory, Link } from "react-router-dom";

import { API_URL, scroll, getValFromLS, consoilidatedGuests } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";
import Radios from "../components/Radios";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Table from "./Table";
import Table2 from "./Table2";
import Nav from "./Nav";

import InviteDonateFields from "./InviteDonateFields";
import InviteFields from "./InviteFields";

const Invite = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [allFilled, setAllFilled] = useState(false);
	const [golf, setGolf] = useState({});
	const [sporting, setSporting] = useState({});
	const [welcome, setWelcome] = useState({});
	const [gift, setGift] = useState({});
	const [open, setOpen] = useState({
		level: false,
		golf: false,
		sporting: false,
		welcome: false,
		gift: false,
	});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		event1: "",
	});
	const [msg, setMsg] = useState({});
	const [notice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardInviteInit`);
			const params = {
				id: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					if (json.allFilled) {
						setAllFilled(true);
					} else {
						setDetails({
							events1: json.events1,
							events2: json.events2,
							events3: json.events3,
							golfTeamsRemaining: json.golfTeamsRemaining,
							sportingTeamsRemaining: json.sportingTeamsRemaining,
						});
					}
					setGolf({ ...json.golf });
					setSporting({ ...json.sporting });
					setWelcome({ ...json.welcome });
					setGift({ ...json.gift });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		if (name === "method" && value === "yourself") {
			setNames((names) => ({
				...names,
				fname: user.fname,
				lname: user.lname,
				email: user.email,
				confirm: user.email,
			}));
		} else if (name === "method") {
			setNames((names) => ({
				...names,
				fname: "",
				lname: "",
				email: "",
				confirm: "",
			}));
		}

		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleCheckboxes = (name, checked, val) => {
		let newValue = "";
		if (checked) {
			newValue = val;
		}
		setNames((names) => ({ ...names, [name]: newValue }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardInvite`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				/*
					setNotice({
						type: "success",
						text: json.text,
					});
					formElement.current.reset();

					if (names.method !== "donate") {
						formElement.current.event1.checked = true;
					}

					setNames({
						event1: "",
					});
					setMsg({});
					scroll();
				*/

				history.push({
					pathname: `/dashboard`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleToggle = (id) => {
		const newOpen = !open[id];
		setOpen({ ...open, [id]: newOpen });
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Add / Invite Guests" />

						<p>
							Use this form to add and invite guests to BFC events under your
							Sponsor Registration.
						</p>

						<p>
							If one of your guests can no longer attend, please click{" "}
							<Link to="/dashboard/statuses">“View All Guests”</Link>, click on
							your guest's name, and then click the trash can icon ({" "}
							<i className="fa fa-trash error fa-lg" /> ) under the remove
							column. This will allow you to enter in a new guest to fill their
							spot.
						</p>

						<p>
							Please note that removing the guest from the event will trigger an
							automatic email notification to your guest.
						</p>

						{notice.type && <Notice data={notice} />}

						<div className="spacer"></div>

						{allFilled ? (
							<Alert
								data={{
									type: "notice",
									text: "All your available invitation spots have been filled, thank you.",
								}}
							/>
						) : (
							<form
								ref={formElement}
								method="post"
								action="/"
								onSubmit={(e) => handleSubmit(e)}
								className="well"
							>
								<h4
									style={{
										marginTop: "0",
										lineHeight: "22px",
										marginBottom: "10px",
										fontSize: "1.1rem",
									}}
								>
									Add Guest / Send Email Invite
								</h4>

								{/* removed 12/6/22
                  {
                    name: "method",
                    val: "queue",
                    label:
                      "Queue sending email invite to guest at a later date",
                  },
                */}

								<div
									className="form-group radios"
									style={{ marginTop: "15px", marginBottom: "15px" }}
								>
									<Radios
										label="Please select:"
										reqd={true}
										data={[
											{
												name: "method",
												val: "yourself",
												label: "Add yourself to event(s)",
											},
											{
												name: "method",
												val: "add",
												label: "Immediately add guest to event(s)",
											},
											{
												name: "method",
												val: "invite",
												label: "Send email invite to guest",
											},
											{
												name: "method",
												val: "donate",
												label: "Donate back a team",
												disabled:
													details.golfTeamsRemaining === 0 &&
													details.sportingTeamsRemaining === 0
														? true
														: false,
											},
										]}
										value={names.payment || ""}
										click={handleUpdate}
									/>
								</div>

								{/* not used
									names.method === "queue" && (
									<h4
										style={{
											marginTop: "0",
											lineHeight: "22px",
											marginBottom: "10px",
											fontSize: "1.1rem",
										}}
									>
										Send Invite at a Later Date
									</h4>
								)}
								{names.method === "queue" && (
									<div className="form-group">
										<InputDate
											name="date"
											label="Date"
											reqd={true}
											value={names.date || ""}
											autocomplete=""
											update={handleUpdate}
											errors={errors}
										/>

										<div className="empty" />
									</div>
								)*/}

								{names.method === "donate" ? (
									<InviteDonateFields
										handleUpdate={handleUpdate}
										errors={errors}
										golfTeamsRemaining={details.golfTeamsRemaining}
										sportingTeamsRemaining={details.sportingTeamsRemaining}
									/>
								) : (
									<InviteFields
										names={names}
										handleUpdate={handleUpdate}
										errors={errors}
										details={details}
										handleCheckboxes={handleCheckboxes}
									/>
								)}

								<div className="msg-submit">
									{msg.type && <Msg data={msg} />}

									<div
										className={
											msg.type === "working" || msg.type === "success"
												? "hidden"
												: "submit-container"
										}
									>
										<Submit
											submit={
												names.method === "donate"
													? "Donate Team"
													: "Add / Invite Guest"
											}
										/>
									</div>
								</div>
							</form>
						)}

						<Table2
							data={consoilidatedGuests(
								golf.data,
								sporting.data,
								welcome.data,
								gift.data,
							)}
						/>

						{golf.data.length > 0 && (
							<Table
								details={golf}
								id="golf"
								open={open.golf}
								toggle={handleToggle}
							/>
						)}
						{sporting.data.length > 0 && (
							<Table
								details={sporting}
								id="sporting"
								open={open.sporting}
								toggle={handleToggle}
							/>
						)}
						{welcome.data.length > 0 && (
							<Table
								details={welcome}
								id="welcome"
								open={open.welcome}
								toggle={handleToggle}
							/>
						)}
						{gift.data.length > 0 && (
							<Table
								details={gift}
								id="gift"
								open={open.gift}
								toggle={handleToggle}
							/>
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={2} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Invite;
